// eslint-disable-next-line import/prefer-default-export
export const PREFIX_SESSION_STATE_NAME = 'prox_modos_pagamento_state';
